import wbMini from "@/assets/images/wbMini.png";
import ozonMini from "@/assets/images/ozonMini.png";
import yandexMini from "@/assets/images/yandexMini.svg";
import chZnMini from "@/assets/images/chZnak.svg";

export enum MarketPlace {
  Ozon,
  Wildberries,
  YandexMarket,
  ChestniyZnak,
}

export const MARKET_PLACE_NAME_BY_TYPE: Record<MarketPlace, string> = {
  [MarketPlace.Ozon]: "Ozon",
  [MarketPlace.Wildberries]: "Wildberries",
  [MarketPlace.YandexMarket]: "YandexMarket",
  [MarketPlace.ChestniyZnak]: "Честный знак",
};

export const MARKET_PLACE_ICON_BY_TYPE: Record<MarketPlace, string> = {
  [MarketPlace.Ozon]: ozonMini,
  [MarketPlace.Wildberries]: wbMini,
  [MarketPlace.YandexMarket]: yandexMini,
  [MarketPlace.ChestniyZnak]: chZnMini,
};

export const MARKET_PLACE_OPTIONS = Object.values(MarketPlace)
  .filter((val): val is MarketPlace => typeof val === "number")
  .map((item: MarketPlace) => ({
    value: item,
    label: MARKET_PLACE_NAME_BY_TYPE[item],
  }));
